export const FoodData = [
                                            {
                                                "id": "2568358",
                                                "imageId": "PC_Mweb/North%20Indian.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83633?collection_id=83633&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                                    "text": "North Indian",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for north indian",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83633?collection_id=83633&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568016",
                                                "imageId": "PC_Mweb/Pizza.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                                    "text": "Pizzas",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for pizza",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568574",
                                                "imageId": "PC_Mweb/Burger.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                                    "text": "Burgers",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for burger",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568034",
                                                "imageId": "PC_Mweb/Rolls.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                                    "text": "Rolls",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for roll",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568009",
                                                "imageId": "PC_Mweb/Chinese.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                                    "text": "Chinese",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for chinese",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568353",
                                                "imageId": "PC_Mweb/Momo.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                                    "text": "Momos",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for momos",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568312",
                                                "imageId": "PC_Mweb/Cake.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                                    "text": "Cakes",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for cake",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568339",
                                                "imageId": "PC_Mweb/Biryani.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                                    "text": "Biryani",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for biryani",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568326",
                                                "imageId": "PC_Mweb/Ice%20Cream.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83640?collection_id=83640&tags=layout_CCS_IceCreams&type=rcv2",
                                                    "text": "Ice Cream",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for icecream",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83640?collection_id=83640&tags=layout_CCS_IceCreams&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568142",
                                                "imageId": "PC_Mweb/Dosa.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                                    "text": "Dosa",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for dosa",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568346",
                                                "imageId": "PC_Mweb/Noodles.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
                                                    "text": "Noodles",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for noodles",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568041",
                                                "imageId": "PC_Mweb/Pasta.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
                                                    "text": "Pasta",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for pasta",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568033",
                                                "imageId": "PC_Mweb/Kebab.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80451?collection_id=80451&type=rcv2",
                                                    "text": "Kebabs",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for kebabs",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80451?collection_id=80451&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568348",
                                                "imageId": "PC_Mweb/South%20Indian.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                                    "text": "South Indian",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for south indian",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568360",
                                                "imageId": "PC_Mweb/Pure%20Veg.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                                    "text": "Pure Veg",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for veg",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568341",
                                                "imageId": "PC_Mweb/Pastry.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2",
                                                    "text": "Pastry",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for Pastry",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568330",
                                                "imageId": "PC_Mweb/Shawarma.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                                    "text": "Shawarma",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for shawarma",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568359",
                                                "imageId": "PC_Mweb/Paratha.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80475?collection_id=80475&type=rcv2",
                                                    "text": "Paratha",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurants curated for paratha",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80475?collection_id=80475&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568573",
                                                "imageId": "PC_Mweb/Gulab%20Jamun.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80430?collection_id=80430&type=rcv2",
                                                    "text": "Gulab Jamun",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for gulab jamun",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80430?collection_id=80430&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }, {
                                                "id": "2568337",
                                                "imageId": "PC_Mweb/Pav%20Bhaji.png",
                                                "action": {
                                                    "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                                    "text": "Pav Bhaji",
                                                    "type": "DEEPLINK"
                                                },
                                                "entityType": "BANNER",
                                                "accessibility": {
                                                    "altText": "restaurant curated for pav bhaji",
                                                    "altTextCta": "open"
                                                },
                                                "entityId": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                                "frequencyCapping": {},
                                                "externalMarketing": {},
                                                "overlayIcon": {}
                                            }]